import classNames from "classnames";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Card, Col, Form, Label, Row } from "reactstrap";
import {
  BlockDes,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  ReactDataTable,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { useDataFetch } from "../../../hooks/useDataFetch";

const GraphPage = () => {
  const [item, setItem] = useState();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const onFormSubmit = (e) => {
    updateConfig({
      id: item.id,
      ...e,
    });
  };

  const formClass = classNames({
    "form-validate": true,
  });

  const { getData, patchData, invalidateQuery } = useDataFetch();

  const { data, isLoading, refetch } = getData(
    ["statistics"],
    "/panel/statistics",
    { enabled: true }
  );

  const { mutate: updateConfig, isLoading: isPostLoading } = patchData(
    "/panel/statistics",
    {},
    {},
    {
      onSuccess: (data) => {
        reset();
        invalidateQuery(["statistics"]);
      },
    }
  );

  useEffect(() => {
    if (data && data?.length > 0) {
      setItem(data[0]);
      setValue("tree_2024", data[0]["tree_2024"]);
      setValue("tree_2025", data[0]["tree_2025"]);
      setValue("tree_2026", data[0]["tree_2026"]);
      setValue("tree_2027", data[0]["tree_2027"]);
      setValue("aves", data[0]["aves"]);
      setValue("mamiferos", data[0]["mamiferos"]);
      setValue("plantas", data[0]["plantas"]);
      setValue("herpetos", data[0]["herpetos"]);
      setValue("co2_2024", data[0]["co2_2024"]);
      setValue("co2_2025", data[0]["co2_2025"]);
      setValue("co2_2026", data[0]["co2_2026"]);
      setValue("co2_2027", data[0]["co2_2027"]);
    }
  }, [data]);

  return (
    <React.Fragment>
      <Head title="Estadísticas"></Head>
      <Content>
        <Form className={formClass} onSubmit={handleSubmit(onFormSubmit)}>
          <Card className="p-4">
            <BlockHeadContent>
              <BlockTitle tag="h4">
                Información para las estadísticas
              </BlockTitle>
              <BlockDes></BlockDes>
            </BlockHeadContent>
          </Card>
          <Card className="">
            <div className="">
              <div className={` p-4`}>
                <Row className="g-gs">
                  <Col md="12">
                    <BlockHeadContent>
                      <BlockTitle tag="h4">
                        Número de árboles sembrados
                      </BlockTitle>
                      <BlockDes></BlockDes>
                    </BlockHeadContent>
                    <Row>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Árboles proyectados 2024
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("tree_2024", { required: true })}
                              className="form-control"
                            />
                            {errors.tree_2024 && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Árboles proyectados 2025
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("tree_2025", { required: true })}
                              className="form-control"
                            />
                            {errors.tree_2025 && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Árboles proyectados 2026
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("tree_2026", { required: true })}
                              className="form-control"
                            />
                            {errors.tree_2026 && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Árboles proyectados 2027
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("tree_2027", { required: true })}
                              className="form-control"
                            />
                            {errors.tree_2027 && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          </Card>
          <Card className="">
            <div className="">
              <div className={` p-4`}>
                <Row className="g-gs">
                  <Col md="12">
                    <BlockHeadContent>
                      <BlockTitle tag="h4">
                        Riqueza de especies nativas
                      </BlockTitle>
                      <BlockDes></BlockDes>
                    </BlockHeadContent>
                    <Row>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Aves
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("aves", { required: true })}
                              className="form-control"
                            />
                            {errors.aves && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Mamíferos
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("mamiferos", { required: true })}
                              className="form-control"
                            />
                            {errors.mamiferos && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Plantas
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("plantas", { required: true })}
                              className="form-control"
                            />
                            {errors.plantas && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Herpetos
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("herpetos", { required: true })}
                              className="form-control"
                            />
                            {errors.herpetos && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          </Card>
          <Card className="">
            <div className="">
              <div className={` p-4`}>
                <Row className="g-gs">
                  <Col md="12">
                    <BlockHeadContent>
                      <BlockTitle tag="h4">
                        Potencial de captura de CO2
                      </BlockTitle>
                      <BlockDes></BlockDes>
                    </BlockHeadContent>
                    <Row>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Potencial de captura de CO2 real 2024
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("co2_2024", { required: true })}
                              className="form-control"
                            />
                            {errors.co2_2024 && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Potencial de captura de CO2 real 2025
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("co2_2025", { required: true })}
                              className="form-control"
                            />
                            {errors.co2_2025 && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Potencial de captura de CO2 real 2026
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("co2_2026", { required: true })}
                              className="form-control"
                            />
                            {errors.co2_2026 && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="3" lg="3">
                        <div className="form-group mt-4">
                          <Label className="form-label" htmlFor="fv-full-name">
                            Potencial de captura de CO2 real 2027
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              type="number"
                              id="fv-full-name"
                              {...register("co2_2027", { required: true })}
                              className="form-control"
                            />
                            {errors.co2_2027 && (
                              <span className="invalid">
                                Este campo es requerido
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          </Card>
          <Card className="p-4">
            <Row>
              <Col md="12">
                <div className="form-group">
                  <Button color="primary" size="lg">
                    Actualizar
                  </Button>
                </div>
              </Col>
            </Row>
          </Card>
        </Form>
      </Content>
    </React.Fragment>
  );
};

export default GraphPage;
